<div class="modal d-block fm-modal fm-confirm-modal" tabindex="-1" role="dialog" (click)="onBackdropClick($event)"
  id="addFamilyMemberModal">
  <div class="modal-dialog modal-dialog-centered fm-modal-dialog fm-confirm-modal-dialog" role="document">
    <div class="modal-content fm-modal-content fm-confirm-modal-content">

      <div class="modal-header fm-modal-header">
        <h5 class="fm-head-20" id="addFamilyMemberModalLabel">{{ title() }}</h5>
        <button type="button" class="btn-close fm-confirm-close" (click)="close()" aria-label="Close"></button>
      </div>

      <div class="fm-modal-body">
        <!-- <div class="fm-confirm-icon-wrap fm-confirm-icon-danger">
          <img src="images/icons/fm-trash.svg" alt="" class="fm-svg fm-confirm-icon" />
        </div> -->
        <!-- <h5 class="fm-head-28 mt-3 mb-2">{{ title() }}</h5> -->
        <p class="fm-confirm-desc" [innerHTML]="message()"></p>
      </div>

      <div class="fm-modal-footer">
      <div class="row g-2 w-100 justify-content-end">
        <div class="col-12 col-sm-auto">
            <button type="button" class="fm-common-btn fm-border-btn w-100" (click)="cancel()">{{ cancelButtonText()
              }}</button>
          </div>
          <div class="col-12 col-sm-auto">
            <button type="button" class="fm-common-btn w-100" (click)="confirmDelete()">
              <img src="images/icons/fm-trash.svg" alt="" class="fm-svg"
                style="width:16px;height:16px;filter:brightness(0) invert(1)" />
              {{ confirmButtonText() }}
            </button>
          </div>
      </div>
    </div>

    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>